@if (sitecoreEventDetailsVM$ | async; as sitecoreEventDetailsVM) {
    <div class="darts-scoreboard-header">
        @if (sets && score.matchType === matchType.SetsAndLegs) {
            <div class="column">
                <div class="cell sets">{{ sitecoreEventDetailsVM.sets }}</div>
            </div>
        }
        @if (legs) {
            <div class="column">
                <div class="cell legs">{{ sitecoreEventDetailsVM.legs }}</div>
            </div>
        }
    </div>
}
